<template>
    <div class="select-container" :class="{open: isOpen, nobor: border==false}" v-on-clickaway="away">
        <div class="select-input" :class="{disabled: itemId==''}">
            <span class="fa fa-angle-down cross"></span>
            <div type="text" class="form-control form-control-sm" @click="onFocus">{{keyWord}}</div>
        </div>
        <div class="select-dropdown vld-parent" ref="i100" style="min-height: 30px;">
            <table class="table-select">
                <tbody>
                    <tr v-for="(ret,index) in list" :key="index" @click="select(ret)">
                        <td>{{ret.UomName}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        mixins: [ clickaway ],
        props: {
            item_id: String,
            value: {
                type: String,
                default: ''
            },
            border: {
                type: Boolean,
                default: true
            },
            place: {
                type: String,
                default: ''
            },  
        },
        data: function(){
            return {
                keyWord: this.value,
                itemId: this.item_id,
                isOpen: false,
                list: [],
                isShow: false
            }
        },
        methods: {
            toList(){
                this.list = [];
                var loading = this.$loading.show({
                    container: this.$refs.i100,
                    height: 22,
                    loader: 'dots'
                });
                this.$api().post('item/uoms', { Id: this.itemId }).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.ItemPrices;
                        if(this.list.length > 0){
                            this.isShow = true;
                        }
                    }
                }).finally(function(){ loading.hide(); });
            },
            onFocus(){
                if(this.item_id != ''){
                    this.isOpen = true;
                    if(!this.isShow)
                        this.toList();
                }
            },
            away() {
                this.isOpen = false;
            },
            select(item){
                this.isOpen = false;
                this.keyWord = item.UomName;
                this.$emit('select', item);
            }
        },
        watch: {
            item_id(val){
                this.itemId = val;
                this.toList();
            },
            value(value){
                this.keyWord = value;
            }
        }
    }
</script>